import { store } from '../../redux/store';
import { authActions } from 'tenantUser/redux/authActions';

export interface ISessionService {
    logoff: () => void;
}

class SessionService implements ISessionService {
    static #instance: SessionService | null = null;

    private constructor() {
        return;
    }

    static getInstance(): SessionService {
        if (!SessionService.#instance) {
            SessionService.#instance = new SessionService();
        }

        return SessionService.#instance;
    }

    logoff(): void {
        store.dispatch(authActions.setLogout());
    }
}

export default SessionService;
